import { observer } from "mobx-react-lite";
import type { FC } from "react";
import type { Form } from "../../../../components/form/form";
import type { PaymentPageForm } from "../../../../types/paymentPage";
import styles from "./businessDetailsSection.module.scss";

type BusinessDetailsSectionType = {
  form: Form<PaymentPageForm>;
};

export const BusinessDetailsSection: FC<BusinessDetailsSectionType> = observer(({ form }) => {
  const hasFilledBusinessDetails = [form].filter(Boolean).length > 0;
  return (
    <>
      {hasFilledBusinessDetails ? (
        <div className={styles.businessDetailsSection}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>
              <span className={styles.sectionSubtitle}>Business details</span>
              <span className={styles.sectionDescription}>These are additional details included on your page</span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
});
